export { default as LabelNavigation } from "./LabelNavigation";
